import { whatsappLinks } from "@/apiUtils/constants";
import X from "@/assets/icons/close.svg?react";
import whatsappIcon from "@/assets/icons/whatsapp.svg";
import { TranslationData } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import { getCountryCodeFromLocale } from "@/utils/common";
import Image from "next/image";
import { CLink } from "@/components/common/customLink/CustomLink";

interface IProps {
  locale: string;
  className?: string;
  translations: TranslationData;
  onCloseLensConfigurator?: () => void;
}

const Help = ({ onCloseLensConfigurator, className, translations, locale }: IProps) => {
  return (
    <div className={cn("flex items-center gap-5", className)}>
      {whatsappLinks[getCountryCodeFromLocale(locale)] ? (
        <CLink href={whatsappLinks[getCountryCodeFromLocale(locale)]} target="_blank">
          <button className="flex items-center gap-2 bg-primary-2 px-5 py-2">
            <div className="w-6">
              <Image
                width={20}
                height={20}
                alt="WhatsApp icon"
                src={whatsappIcon.src}
                className="h-full w-full"
              />
            </div>
            <div className="text-center text-[0.813rem]">
              <p>{translations?.lensConfigurator?.lens_config_header_whatsapp_subtitle}</p>
              <p>{translations?.lensConfigurator?.lens_config_header_whatsapp_title}</p>
            </div>
          </button>
        </CLink>
      ) : null}
      {onCloseLensConfigurator && (
        <button aria-label="Close" onClick={onCloseLensConfigurator}>
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default Help;
